import { Controller } from "@hotwired/stimulus";

// Drop-in replacement behaviour for non-negative decimal price inputs.
//
// Native type="number" inputs reject the empty intermediate state (the
// field snaps back to its last valid value), which makes a detected price
// impossible to clear and retype. These fields are rendered as
// type="text" inputmode="decimal" instead, and this controller keeps the
// value to a single non-negative decimal, normalizing a French comma to a
// dot so the submitted value is always dot-form — safe for both the
// comma-normalizing import paths and the un-normalized standalone form.
export default class extends Controller {
  sanitize(event) {
    const input = event.target;
    const cleaned = this.clean(input.value);
    if (cleaned !== input.value) {
      const atEnd = input.selectionStart === input.value.length;
      input.value = cleaned;
      // Keep the caret at the end when the user is typing at the end;
      // otherwise leave the browser's default position.
      if (atEnd) {
        input.setSelectionRange(cleaned.length, cleaned.length);
      }
    }
  }

  clean(value) {
    // Comma -> dot, then keep only digits and dots.
    let result = value.replace(/,/g, ".").replace(/[^0-9.]/g, "");
    // Collapse to a single decimal separator (keep the first dot only).
    const firstDot = result.indexOf(".");
    if (firstDot !== -1) {
      result =
        result.slice(0, firstDot + 1) +
        result.slice(firstDot + 1).replace(/\./g, "");
    }
    return result;
  }
}
